import { ReactElement, CSSProperties } from "react";

export function ColorBlocks2({
    id,
    className,
    style
}: {
    id?: string;
    className?: string;
    style?: CSSProperties;
}): ReactElement {
    const lg = "#60AADB";
    const md = "#F37232";
    const sm = "#E4CB34";

    return (
        <svg
            id={id}
            className={className}
            style={style}
            width="89"
            height="74"
            viewBox="0 0 89 74"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="16.5%" y="79%" width="16%" height="20%" fill={sm} />
            <rect y="39%" width="33%" height="40%" fill={lg} />
            <rect x="33%" width="66%" height="79%" fill={md} />
        </svg>
    );
}
